import { useTranslation } from "react-i18next";
import { useState } from "react";
import PolicyDetails from "../PolicyDetails";
import { CreatePolicyType } from "../type";
import { createInitialState } from "../state";
import RenewalHeader from "../RenewalHeader";
import classNamePresets from "../../../../utils/classNamePresets";
import { H2 } from "../../../../components/basics";
import agentApiService, { RenewalCheckoutRequest } from "../../../../services/pay_now/agentApiService";
import { Region } from "../../../../enums/shared/forms/Region";
import RenewalFooter from "../components/RenewalFooter";

const HKRenewalPolicyDetails = () => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.payNow.hk" });
  const { t: footer } = useTranslation("pages", { keyPrefix: "travel.payNow.hkFooter" });
  const [state, setState] = useState<CreatePolicyType>(createInitialState);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const handleSubmit = async () => {
    //checkout API for HK renewal Details
    const requestData: RenewalCheckoutRequest = {
      policyNumber: state.policyNumber,
      insuredName: state.insuredName,
      contactNumber: state.contactNumber,
      amount: parseFloat(state.amount),
      email: state.email,
      type: Region.HK,
    };
    try {
      setSubmitting(true);
      const response = await agentApiService.genericCheckout(requestData);
      window.location.href = response.url;
    } catch (error) {
      console.error(error);
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen gap-0">
      {/* Hk renewal policy details */}
      <RenewalHeader />
      <div className="container-flow flex-grow md:pt-[64px] pt-8">
        <H2 className={classNamePresets.mainHeading}>{t("title")}</H2>
        <p>{t("subtitle")}</p>
        <p className="mt-4">{t("subtitle1")}</p>
        <PolicyDetails t={t} state={state} setState={setState} onSubmit={handleSubmit} submitting={submitting} />
      </div>
      <RenewalFooter footer={footer} />
    </div>
  );
};

export default HKRenewalPolicyDetails;
